import React from 'react';
import toast from 'react-hot-toast';
import { routePaths } from '../../routes/routes-path';
import { apiErrorMessage } from '../../utils/api-error-message';
import { apiErrorCode, ERROR_CODE, OrderFunding } from '../../utils/individual-order';
import { isOrdererBlockCode, notifySanctionChanged } from '../../utils/brand-sanction';
import { showNeedToRateToast } from './brand-rating-pending';

/** Thiếu Ca nạp: hiện nguyên câu kèm nút Nạp Ca (Toaster nằm ngoài router nên dùng thẻ a thường). */
export const showTopUpCaToast = (message: string) =>
  toast.error(
    <span className="flex flex-wrap items-center gap-2">
      <span>{message}</span>
      <a
        href={routePaths.wallet}
        className="shrink-0 rounded-full border border-[#0057FF] px-2.5 py-1 text-[12px] font-semibold text-[#0057FF]"
      >
        Nạp Ca
      </a>
    </span>,
    { duration: 8000 }
  );

export const showFundingShortfall = (f: OrderFunding, message: string) =>
  f.kind === 'Individual' ? showTopUpCaToast(message) : toast.error(message);

/** Lỗi khi tạo chiến dịch/mời/đặt/đăng sàn/duyệt đơn: bị xử phạt hoặc nằm trong danh sách đen thì hiện nguyên câu BE
 * và báo thanh khoá tải lại; thiếu Ca nạp thì kèm Nạp Ca; còn lại giữ hành vi cũ (nhắc chấm điểm nếu đúng lý do). */
export const showOrderErrorToast = (err: unknown, fallback: string, onGoToRatingsTab?: () => void) => {
  const message = apiErrorMessage(err, fallback);
  if (isOrdererBlockCode(apiErrorCode(err))) {
    toast.error(message, { duration: 8000 });
    notifySanctionChanged();
    return;
  }
  if (apiErrorCode(err) === ERROR_CODE.topUpCaInsufficient) {
    showTopUpCaToast(message);
    return;
  }
  showNeedToRateToast(message, onGoToRatingsTab);
};
